import { Component, OnInit } from '@angular/core';
import {WebNavigationService} from "../../navigation.service";

@Component({
  selector: 'app-promotions-options',
  templateUrl: './promotions-option.component.html',
  styleUrls: ['./promotions-option.component.scss']
})
export class PromotionsOptionComponent implements OnInit {

  constructor(private navigationService: WebNavigationService) { }

  ngOnInit() {
  }


    get selectedOption() {
        return this.navigationService.selectedOption;
    }

    get expanded() {
        return this.navigationService.expanded;
    }

    get expandPromotions() {
        return this.navigationService.expandPromotions;
    }

    selectOption(option) {
        this.navigationService.selectOption(option);
    }

    selectPromotionOption(promotionOption) {
        this.navigationService.selectConciliacionOption(promotionOption);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/options/promotions/promotions-option.component.ts